
import Vue from 'vue'

export default Vue.extend({
  seo: {
    title: 'Octopus Agile ESP32 Display | Aaron Cunliffe',
    description: 'An ESP32 microcontroller project that fetches live Octopus Agile energy prices and displays colour-coded electricity rate indicators.'
  }
})
